import { Data } from "../../types/Data";
import { State } from "../../types/State";

export function getLabelPrix({
  state,
  data,
  defaultLabel,
}: {
  state: State;
  data: Data;
  defaultLabel: string;
}) {
  if (!state["prix-min"]) {
    if (!state["prix-max"]) return defaultLabel;
    return `Jusqu'à ${state["prix-max"]}€`;
  } else if (!state["prix-max"]) return `À partir de ${state["prix-min"]}€`;
  else return `Entre ${state["prix-min"]} et ${state["prix-max"]}€`;
}
